import React from "react";
import "./index.css";
import cn from "classnames";
import Textarea from "../../../layout/Textarea/Textarea";
import ImageUpload from "../../../layout/ImageUpload";
import QRCode from "../../../layout/QRCode";
import {UI, newsletterLayoutTypes} from "../../../data/constants";
import {checkIfIDE} from "../../../data/products/index";
import Icon from "../../../layout/Icon";
import BgTransformer from "../../../layout/BgTransformer";
import {useSetting} from "../../../contexts/setting";
import {useEdits} from "../../../contexts/edits";
import {useImages} from "../../../contexts/images";
import {useBgUrl} from "hooks/useBgUrl";
import {useLogoUrl} from "../../../hooks/useLogoUrl";
import {palettes} from "../../../data/palettes";

const QRcodeFullHD = ({id, zoom}) => {
  const {product, layoutOption, iconOption, type, channel, locked, visible, isUppercase} =
    useSetting();
  const {uploadImages} = useImages();
  const {url: bgUrl} = useBgUrl();
  const {titles, subtitles, subtitles2, subtitles3, links, links2, links3} = useEdits();
  const logoURL = useLogoUrl(id);
  const title = titles[id] || titles.main;
  const subtitle = subtitles[id] || subtitles.main;
  const subtitleSecond = (subtitles2 && (subtitles2[id] || subtitles2.main)) || subtitle;
  const subtitleThird = (subtitles3 && (subtitles3[id] || subtitles3.main)) || subtitle;
  const isNewsletter = newsletterLayoutTypes.includes(type.value);
  const newsletterClass = isNewsletter ? "newsletter" : "";
  const templateClass = cn("template", `layout-${layoutOption}`, newsletterClass);
  const contentClass = cn("content", `layout-${layoutOption}`);
  const uploadClass = cn("upload-wrap", `layout-${layoutOption}`);
  const logoClass = cn("logo", {ide: checkIfIDE(product.value)});
  const isLocked = !locked.some((elem) => elem === id);
  const isVisible = visible.some((elem) => elem === id);
  const link = links[id] || links.main;
  const linkSecond = (links2 && (links2[id] || links2.main)) || link;
  const linkThird = (links3 && (links3[id] || links3.main)) || link;
  const hasCustomQR1 = Boolean(uploadImages?.["custom-qr-1"]);
  const hasCustomQR2 = Boolean(uploadImages?.["custom-qr-2"]);
  const hasCustomQR3 = Boolean(uploadImages?.["custom-qr-3"]);
  const Slot1 = hasCustomQR1 ? (
    <ImageUpload id={"custom-qr-1"} transformKey={`${id}-custom-qr-1`} />
  ) : (
    <QRCode value={link} />
  );
  const Slot2 = hasCustomQR2 ? (
    <ImageUpload id={"custom-qr-2"} transformKey={`${id}-custom-qr-2`} />
  ) : (
    <QRCode value={linkSecond} />
  );
  const Slot3 = hasCustomQR3 ? (
    <ImageUpload id={"custom-qr-3"} transformKey={`${id}-custom-qr-3`} />
  ) : (
    <QRCode value={linkThird} />
  );

  return (
    <>
      <div id={id} className={templateClass} style={{"--zoom-level": zoom}}>
        <div>
          <BgTransformer src={bgUrl} id={id} />
          <div className="content">
            <div className="header">
              <div className={logoClass}>
                <img src={logoURL} alt="background" />
              </div>

              <div className="title-wrap">
                <h1 className="title">
                  <Textarea id={id} text={title} />
                </h1>
              </div>
            </div>
            {+layoutOption === 1 && (
              <div className="qr-card">
                <div className="qr-code">
                  {hasCustomQR1 ? <ImageUpload id={"custom-qr-1"} /> : <QRCode value={link} />}
                </div>
                <div>
                  <h2 className="subtitle">
                    <Textarea id={id} lines="1" text={subtitle} />
                  </h2>
                </div>
              </div>
            )}
            {+layoutOption === 2 && (
              <div className="card-deck">
                <div className="qr-card">
                  <h2 className="subtitle">
                    <Textarea id={id} lines="1" text={subtitle} />
                  </h2>
                  <div className="card-content">
                    <div className="qr-code">{Slot1}</div>
                  </div>
                </div>
                <div className="qr-card">
                  <h2 className="subtitle2">
                    <Textarea id={id} lines="1" text={subtitleSecond} />
                  </h2>
                  <div className="card-content">
                    <div className="qr-code">{Slot2}</div>
                  </div>
                </div>
              </div>
            )}
            {+layoutOption === 3 && (
              <div className="card-deck">
                <div className="qr-card">
                  <h2 className="subtitle">
                    <Textarea id={id} lines="1" text={subtitle} />
                  </h2>
                  <div className="card-content">
                    <div className="qr-code">{Slot1}</div>
                  </div>
                </div>
                <div className="qr-card">
                  <h2 className="subtitle2">
                    <Textarea id={id} lines="1" text={subtitleSecond} />
                  </h2>
                  <div className="card-content">
                    <div className="qr-code">{Slot2}</div>
                  </div>
                </div>
                <div className="qr-card">
                  <h2 className="subtitle3">
                    <Textarea id={id} lines="1" text={subtitleThird} />
                  </h2>
                  <div className="card-content">
                    <div className="qr-code">{Slot3}</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default QRcodeFullHD;
